import { css } from 'styled-components';

const StandardSideMargin = css`
  margin: 0 ${(props) => props.theme.spacing(30)};
`;

export default StandardSideMargin;
